<div class="dropdown-wrapper" [class.disabled]="isDisabled">
    <label class="dropdown-label">
        {{ label }}
        @if (required) {
<span class="text-danger">*</span>
}
    </label>

    <div #dropdownToggle class="dropdown-container" [class.disabled]="isDisabled" (click)="toggleDropdown()"
        [attr.data-id]="dataId">
        <div class="dropdown-selected" [class.invalid]="control?.invalid && (control.dirty || control.touched)"
            [class.placeholder]="isPlaceholderShown()">
            {{ getDisplayValue() }}
        </div>
        <div class="dropdown-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></div>
    </div>

    @if (dropdownOpen) {
<ul class="options-list">
        @for (option of formattedOptions; track option) {
<li class="dropdown-option" (click)="selectOption(option)">
            {{ option.label }}
        </li>
}
        @if (formattedOptions.length === 0) {
<li class="no-options">No options available</li>
}
    </ul>
}

    @if (control?.invalid && (control.dirty || control.touched)) {
<div class="text-danger">
        @if (control.errors?.required) {
<div>This field is required.</div>
}
    </div>
}
</div>